// src/store/courierData.js
export default {
  namespaced: true,
  state: () => ({
    data: null, // Datos del courier
    lastUpdated: null // Timestamp de la última actualización
  }),
  mutations: {
    // Guardar o actualizar los datos del courier
    setCourierData(state, courierData) {
      state.data = courierData
      // Actualizar timestamp
      state.lastUpdated = new Date().getTime()
    },
    // Limpiar los datos del courier
    clearCourierData(state) {
      state.data = null
      state.lastUpdated = null
    }
  },
  getters: {
    // Obtener los datos del courier
    getCourierData: (state) => state.data,
    
    // Obtener timestamp de última actualización
    getLastUpdated: (state) => state.lastUpdated,
    
    // Verificar si hay datos en caché
    hasCourierData: (state) => !!state.data,
    
    // Obtener el estado de trabajo del courier (online/offline)
    isWorking: (state) => state.data ? state.data.is_working === 1 : false,
    
    // Obtener la zona de trabajo seleccionada
    getWorkingZone: (state) => state.data ? state.data.id_working_zone : null
  },
  actions: {
    // Acción para actualizar los datos del courier en el store
    updateCourierData({ commit }, courierData) {
      commit('setCourierData', courierData)
    }
  }
}
